import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Connexion impossible.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-bz-ivory px-6">
      <meta name="robots" content="noindex, nofollow" />
      <title>Administration — BENZENATI</title>
      <div className="w-full max-w-md">
        <div className="mb-10 text-center">
          <span className="font-serif text-3xl tracking-[0.28em] text-bz-navy">BENZENATI</span>
          <p className="mt-2 text-xs uppercase tracking-[0.22em] text-bz-slate">Espace d'administration</p>
        </div>
        <form onSubmit={submit} className="border border-bz-line bg-white p-8 lg:p-10" data-testid="admin-login-form" noValidate>
          <label className="block">
            <span className="bz-label text-bz-slate">Adresse électronique</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="mt-3 w-full border border-bz-line bg-bz-ivory px-4 py-3 text-base text-bz-navy outline-none focus:border-bz-petrol"
              required
            />
          </label>
          <label className="mt-6 block">
            <span className="bz-label text-bz-slate">Mot de passe</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="mt-3 w-full border border-bz-line bg-bz-ivory px-4 py-3 text-base text-bz-navy outline-none focus:border-bz-petrol"
              required
            />
          </label>
          {error && <p className="mt-5 text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-8 inline-flex w-full items-center justify-center bg-bz-navy px-8 py-4 text-xs uppercase tracking-[0.18em] text-bz-ivory transition-colors hover:bg-bz-petrol disabled:opacity-60"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
